import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import PWABottomNav from './components/PWABottomNav'
import CartPanel from './components/CartPanel'
import PWAInstallPrompt from './components/PWAInstallPrompt'
import { CartProvider } from './context/CartContext'

const App = () => {
  const location = useLocation()

  // Detect PWA standalone mode for bottom padding + global CSS class
  const [isStandalone] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.navigator.standalone === true ||
      window.matchMedia('(display-mode: standalone)').matches
  })

  // Track PWA nav edge position for conditional footer padding
  const [navEdge, setNavEdge] = useState(() => {
    if (typeof window === 'undefined') return 'bottom'
    return sessionStorage.getItem('pwa_nav_edge') || 'bottom'
  })

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === 'pwa_nav_edge') {
        setNavEdge(e.newValue || 'bottom')
      }
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  useEffect(() => {
    if (isStandalone) {
      document.documentElement.classList.add('pwa-standalone')
    } else {
      document.documentElement.classList.remove('pwa-standalone')
    }
  }, [isStandalone])

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.replace('#', '')
      const element = document.getElementById(targetId)
      if (element) {
        const navOffset = 64
        const scrollPosition = element.getBoundingClientRect().top + window.scrollY - navOffset
        window.scrollTo({ top: Math.max(scrollPosition, 0), behavior: 'smooth' })
        return
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [location])

  return (
    <CartProvider>
      <div className="text-black bg-white">
        <Navigation />
        <main className="pt-20 min-h-screen">
          <Outlet />
        </main>
        <div className="bg-black" style={isStandalone && navEdge === 'bottom' ? { paddingBottom: 'calc(5.5rem + env(safe-area-inset-bottom, 0px))' } : undefined}>
          <Footer />
        </div>
        <PWABottomNav />
        <CartPanel />
        <PWAInstallPrompt />
      </div>
    </CartProvider>
  )
}

export default App
